import { theme } from '@branchjs/neo-components';
import { css } from 'emotion';

export const appsMenuStyles = {
  button: css`
    cursor: pointer;
    display: flex;
    align-items: center;
    color: ${theme.colors.gray[700]};

    &:hover {
      color: ${theme.colors.primary.main};
    }
  `,
  popover: css`
    display: flex;
    justify-content: center;
    padding: 20px;
    gap: 30px;
  `,
};
